import { recommendations } from '@/mocks/bookData';

export default function Recommendations() {
  return (
    <section id="recommend" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
            <i className="ri-team-line"></i>
            同好推荐
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            书友们都在推荐什么
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            来自真实读者的短评与推荐语，用最直接的方式告诉你：这些作品为什么值得补。
          </p>
        </div>
        <span className="inline-flex items-center gap-1.5 self-start rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-800 md:self-auto whitespace-nowrap">
          <i className="ri-sparkling-2-line text-accent-600"></i>
          精选热门书评
        </span>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
        {recommendations.map((r) => (
          <article
            key={r.id}
            className="flex flex-col rounded-xl bg-background-100 p-5 md:p-6"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={`书友 ${r.user} 的头像`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{r.user}</p>
                  <p className="text-xs text-foreground-600">书友</p>
                </div>
              </div>
              <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
                {r.tag}
              </span>
            </div>

            <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
              「{r.text}」
            </p>

            <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
              <div className="flex items-center gap-2">
                <i className="ri-book-line text-accent-600"></i>
                <span className="text-sm font-semibold text-foreground-900">《{r.book}》</span>
                <span className="flex items-center gap-0.5 text-xs text-foreground-500">
                  <i className="ri-star-fill text-accent-600"></i>
                  {r.score.toFixed(1)}
                </span>
              </div>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                有用
              </span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}